import { useCallback } from 'react';
import { authService } from '../service/AuthService';
import { Transporter } from '../interfaces/transporters.interface';
import { AxiosError } from 'axios';

function isAxiosError(error: any): error is AxiosError {
  return error.isAxiosError === true;
}

export const useTransporterRefresh = () => {
  const refreshTransporter = useCallback(async (): Promise<Transporter | null> => {
    try {
      return await authService.refreshUser();
    } catch (error) {
      console.error('Error refreshing transporter data:', error);
      
      // If it's a 409 or 401 error, the auth service will handle clearing data
      // and redirecting, so we don't need to throw the error
      if (isAxiosError(error) && (error.response?.status === 409 || error.response?.status === 401)) {
        return null;
      }
      
      throw error;
    }
  }, []);

  return { refreshTransporter };
};
